import { combineReducers } from 'redux';

import cySecVerification from '../pages/CySecProfileVerification/reducers';
import verification from '../pages/ProfileVerification/reducers';
import profile from '../pages/ProfileData/reducers';

const reducer = combineReducers({
  verification,
  cySecVerification,
  profile,
});

export default reducer;
